// extracted by mini-css-extract-plugin
export var dataCell = "_o1-2";
export var dataRow = "_o1-0";
export var headerRow = "_o1-1";